module.exports = __webpack_public_path__ + "media/images/icon-redesign-service-19fcb35198f4af6271a407de0f82ea62.svg";